import React from 'react';
import iconFacebook from '../../sass/icons/icon-facebook-f.svg';
import iconGoogle from '../../sass/icons/icon-google.svg';
import iconTalkative from '../../sass/icons/icon-talkative.svg';
import costImage from '../../sass/images/cost-image.png';
import costGraph from '../../sass/images/costs-graph@2x.png';
import CostCard from '../Card/Cost';
import TestCTA from '../TestCTA';
import './CostComparation.scss';





const content = [
    {
        icon: iconTalkative,
        title: 'Talkative',
        text: 'No Talkative, você paga entre R$ 4,00 e R$ 1,00 por membro de sua comunidade - e até menos, se sua comunidade passar de 10.000 membros - e não por clique. Então vamos dar um exemplo pra você entender melhor.',
    },
    {
        icon: iconGoogle,
        title: 'Google',
        text: 'No Google, você escolhe uma palavra, cria um anúncio e para cada clique você dificilmente irá pagar menos de R$ 1,20, podendo chegar a mais de R$ 8 . Veja alguns exemplos segundo a ferramenta de palavras-chave do Google:'
    },
    {
        icon: iconFacebook,
        title: 'Facebook',
        text: 'No Facebook, você escolhe um perfil com base em informações e interações pessoais, cria um anúncio e, para cada pessoa que interagir com ele, você dificilmente irá pagar menos de R$ 1,30. Veja alguns exemplos segundo a ferramenta de anúncios do Facebook:'
    }
]

const renderCostCards = data => data.map(item => {
    return (
        <div key={item.title} className="col-4_xs-12">
            <CostCard {...item} />
        </div>
    )
})

const CostComparation = () => {
    return (
        <div className="cost-comparation">
            <div className="container">
                <div className="grid">
                    <div className="col-6_xs-12">
                        <div className="cost-sample">
                            <img src={costImage} alt="Quanto custa?"/>
                            <div className="text-container">
                                <h6>Quanto custa?</h6>
                                <p>Vamos tomar como exemplo quanto você pagaria por um clique de um homem de 30 anos, casado, com ensino superior.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6_xs-12">
                        <img src={costGraph} alt="Comparativo de preços"/>
                        {/* <a className="cta" href="#">
                            <Isvg src={iconPlus} />
                            Saiba mais
                        </a> */}
                    </div>
                </div>
                <div className="grid">
                    { renderCostCards(content) }
                </div>
                <div className="grid">
                    <div className="col-12">
                      <p className="text">
                        Se você anuncia ou já anunciou em alguma dessas ferramentas, sabe como é difícil entender e controlar esses custos. No Talkative, a dinâmica é muito mais simples e barata: você paga entre R$ 4,00 e R$ 1,00 para manter uma pessoa na sua comunidade. Aquela oferta bacana que você já anunciou no Google e no Facebook, pode virar uma ação para que o membro da sua comunidade espalhe com os amigos. Ele vai compartilhar a oferta no Facebook, no Twitter, no Linkedin e com seus contatos no WhatsApp. Essa pessoa tem, em média, 500 amigos nas redes sociais e, lembre-se, 90% acreditam na opinião dela. Independente de quantos cliques isso gerar, o custo ainda será de APENAS R$ 4,00 a R$ 1,00 por mês. Sim, por mês, fixo, sem aumentar conforme a quantidade de ações realizadas. É importante reforçar isso já que, mesmo que realize essa ação, a pessoa continua na comunidade e pode realizar outras. Pode, por exemplo, realizar outras 4 ações por mês, ou muito mais, se você quiser.
                      </p>
                      <p className="pre-cta">Faça as contas.</p>
                      <TestCTA />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CostComparation


// WEBPACK FOOTER //
// ./src/components/CostComparation/index.js